import api from "./api"


// =========================================================
// HELPERS
// =========================================================

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


// =========================================================
// FORM DATA
// =========================================================

export const getAttendanceFormData =
  async () =>
    (
      await api.get(
        "/hr/attendance/form-data"
      )
    ).data


// =========================================================
// SUMMARY
// =========================================================

export const getAttendanceSummary =
  async (params = {}) =>
    (
      await api.get(
        "/hr/attendance/summary",
        {
          params:
            cleanParams(params),
        }
      )
    ).data


// =========================================================
// ATTENDANCE - LISTE
// =========================================================

export const getAttendance =
  async (params = {}) =>
    (
      await api.get(
        "/hr/attendance",
        {
          params:
            cleanParams(params),
        }
      )
    ).data


// Compatibilité avec les anciennes pages / anciens appels

export const getHrAttendance =
  getAttendance


export const listAttendance =
  getAttendance


export const getAttendanceList =
  getAttendance


// =========================================================
// ATTENDANCE - DETAIL
// =========================================================

export const getAttendanceById =
  async (attendanceId) =>
    (
      await api.get(
        `/hr/attendance/${attendanceId}`
      )
    ).data


// =========================================================
// ATTENDANCE - CREATE
// =========================================================

export const createAttendance =
  async (payload) =>
    (
      await api.post(
        "/hr/attendance",
        payload
      )
    ).data


// =========================================================
// ATTENDANCE - UPDATE
// =========================================================

export const updateAttendance =
  async (
    attendanceId,
    payload
  ) =>
    (
      await api.put(
        `/hr/attendance/${attendanceId}`,
        payload
      )
    ).data


// =========================================================
// ATTENDANCE - DELETE
// =========================================================

export const deleteAttendance =
  async (attendanceId) =>
    (
      await api.delete(
        `/hr/attendance/${attendanceId}`
      )
    ).data


// =========================================================
// DEVICES - LISTE
// =========================================================

export const getAttendanceDevices =
  async (params = {}) =>
    (
      await api.get(
        "/hr/attendance/devices",
        {
          params:
            cleanParams(params),
        }
      )
    ).data


// =========================================================
// DEVICES - CREATE
// =========================================================

export const createAttendanceDevice =
  async (payload) =>
    (
      await api.post(
        "/hr/attendance/devices",
        payload
      )
    ).data


// =========================================================
// DEVICES - UPDATE
// =========================================================

export const updateAttendanceDevice =
  async (
    deviceId,
    payload
  ) =>
    (
      await api.put(
        `/hr/attendance/devices/${deviceId}`,
        payload
      )
    ).data


// =========================================================
// DEVICES - DELETE
// =========================================================

export const deleteAttendanceDevice =
  async (deviceId) =>
    (
      await api.delete(
        `/hr/attendance/devices/${deviceId}`
      )
    ).data


// =========================================================
// RAW EVENTS - LISTE
// =========================================================

export const getAttendanceRawEvents =
  async (params = {}) =>
    (
      await api.get(
        "/hr/attendance/raw-events",
        {
          params:
            cleanParams(params),
        }
      )
    ).data


// =========================================================
// RAW EVENTS - CREATE
// =========================================================

export const createAttendanceRawEvent =
  async (payload) =>
    (
      await api.post(
        "/hr/attendance/raw-events",
        payload
      )
    ).data


// =========================================================
// RAW EVENTS - PROCESS
// =========================================================

export const processAttendanceRawEvents =
  async () =>
    (
      await api.post(
        "/hr/attendance/raw-events/process",
        {}
      )
    ).data